"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntroductionActions = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const zustandStore_1 = require("../../zustandStore");
const commonComponents_1 = require("./commonComponents");
const IntroductionActions = () => {
    const { setIsCookieCutterOpen, setShowManageCookies, acceptAll, declineAll, saveConsent } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const handleAccept = () => {
        acceptAll();
        saveConsent();
        setShowManageCookies(false);
        setIsCookieCutterOpen(false);
    };
    const handleDecline = () => {
        declineAll();
        saveConsent();
        setShowManageCookies(false);
        setIsCookieCutterOpen(false);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(commonComponents_1.DialogActionsButton, { onClick: handleAccept, variant: "outlined", "data-testid": "accept-all-cookies", children: "Accept optional cookies" }), (0, jsx_runtime_1.jsx)(commonComponents_1.DialogActionsButton, { onClick: handleDecline, variant: "outlined", "data-testid": "decline-cookies", children: "Decline optional cookies" }), (0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, spacing: 2, style: {
                    marginLeft: '0px',
                    width: '100%',
                }, children: (0, jsx_runtime_1.jsx)(material_1.Grid, { size: 12, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "manage-cookies", onClick: () => setShowManageCookies(true), sx: {
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                            cursor: 'pointer',
                            display: 'inline-block',
                            margin: '0 !important',
                            padding: '0',
                        }, variant: "subtitle1", children: "Manage cookies >" }) }) })] }));
};
exports.IntroductionActions = IntroductionActions;
